/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { BAVEL_APP_MENUS, BavelMenu, BavelSubMenu, FALCON_URLS, PARTNER_PORTAL_URLS } from '@app/auxiliary/config/app-menu';
import { Component, OnInit, inject } from '@angular/core';
import { EXTRANET_KEYS } from '@config/app-config';
import { IFeatureToggleResponse } from '@shared/interfaces/feature-toggle-response.interface';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { Router } from '@angular/router';
import { IUsersService } from '@shared/interfaces/users-service.interface';

const TPN = 'TPN';

@Component({
    selector: 'bv-tool-menu',
    templateUrl: './tool-menu.component.html',
    styleUrls: ['./tool-menu.component.scss'],
    standalone: false
})
export class ToolMenuComponent implements OnInit {
  public allowedOptions: BavelMenu[] = [];
  public showRenovatingPopup: boolean | undefined;
  public menuUrl: string | undefined;
  public openMenu = '';

  private usersService: IUsersService = inject(IUsersService);
  private router: Router = inject(Router);
  private localStorageService: LocalStorageService = inject(LocalStorageService);

  public ngOnInit(): void {
    this.buildUserMenu();
  }

  public showMenuItem(item: string): void {
    this.openMenu = item;
  }

  public unshowMenuItem(): void {
    this.openMenu = '';
  }

  public unshowMenuItemFromIcon(event: any): void {
    if (this.mouseLeavesOnTopSide(event) || (this.mouseLeavesOnBottomSide(event))) {
      this.unshowMenuItem();
    }
  }

  public unshowSubMenuItem(event: any, menu: BavelMenu, submenu: BavelSubMenu): void {
    const subMenuIndex = menu.subMenuOptions!.findIndex(option => option.id === submenu.id) + 1;
    const subMenusOptions = menu.subMenuOptions!.filter(option => option.show).length;

    if (this.mouseLeavesOnRightSide(event)) {
      this.unshowMenuItem();
      return;
    }

    if (this.isASingleOptionSubmenu(subMenusOptions) && this.mouseLeavesOnAnySideExceptLeft(event)) {
      this.unshowMenuItem();
      return;
    }

    if (this.isFirstSubmenuItem(subMenuIndex) && (this.mouseLeavesOnTopSide(event))) {
      this.unshowMenuItem();
      return;
    }

    if (this.isLastSubmenuItem(subMenuIndex, subMenusOptions) && (this.mouseLeavesOnBottomSide(event))) {
      this.unshowMenuItem();
    }
  }

  public optionRoute(option: BavelMenu): string | undefined {
    return option.route;
  }

  public isMenuActive(option: BavelMenu): boolean {
    if (this.router.url.includes(option.url ?? '')) {
      return true;
    } else return false;
  }

  public clickMenu(menu: BavelMenu | BavelSubMenu): void {
    this.menuUrl = menu.url;
    if ((menu.url!).includes('https') || (menu.url!).includes('http')) {
      if (this.localStorageService.get(EXTRANET_KEYS.SHOW_RENOVATING_POPUP) !== false) {
        this.showRenovatingPopup = true;
      } else {
        window.location.href = this.menuUrl ?? '';
      }
    } else {
      this.router.navigateByUrl(this.menuUrl ?? '');
    }
  }

  public onCloseRenovatingPopup(showAgain: boolean): void {
    if (showAgain) {
      this.localStorageService.set(EXTRANET_KEYS.SHOW_RENOVATING_POPUP, false);
    }
    this.showRenovatingPopup = false;
    window.location.href = this.menuUrl ?? '';
  }

  private buildUserMenu(): void {
    this.usersService.isPartnerPortalDigitalArchiveEnabled()
      .subscribe((response: IFeatureToggleResponse) => {
        const menuOptions: BavelMenu[] = JSON.parse(JSON.stringify(BAVEL_APP_MENUS));
        this.setDigitalArchiveUrl(menuOptions, response);
        this.allowedOptions = menuOptions.filter(option => option.allowedRoles.some(role => this.usersService.userHasRole(role)));
        const tpnOption = this.allowedOptions.find(option => option.id === TPN);
        if (tpnOption) {
          tpnOption.subMenuOptions!.forEach(submenu => {
            if (submenu.allowedRoles!.some(role => this.usersService.userHasRole(role))) {
              submenu.show = true;
            }
          })
        }

      });
  }

  private setDigitalArchiveUrl(menuOptions: BavelMenu[], response: IFeatureToggleResponse): void {
    const oldDigitalArchive = menuOptions.find(item => item.old === true && item.id === 'DIGITAL_ARCHIVE');
    oldDigitalArchive!.url = FALCON_URLS.baseUrl + FALCON_URLS.paths.RECEIVED_DOCUMENTS;

    if (response.enabled) {
      oldDigitalArchive!.url = PARTNER_PORTAL_URLS.baseUrl + PARTNER_PORTAL_URLS.paths.DIGITAL_ARCHIVE;
    }
  }

  private isFirstSubmenuItem(subMenuIndex: number): boolean {
    return subMenuIndex === 1;
  }

  private isLastSubmenuItem(subMenuIndex: number, subMenusOptions: number): boolean {
    return subMenuIndex === subMenusOptions;
  }

  private isASingleOptionSubmenu(subMenusOptions: number): boolean {
    return subMenusOptions === 1;
  }

  private mouseLeavesOnTopSide(event: any): boolean {
    const topPosition = 0;
    return event.layerY <= topPosition;
  }

  private mouseLeavesOnBottomSide(event: any): boolean {
    const bottomPosition = 50;
    return event.layerY >= bottomPosition;
  }

  private mouseLeavesOnRightSide(event: any): boolean {
    const rightPosition = 280;
    return event.x >= rightPosition;
  }

  private mouseLeavesOnAnySideExceptLeft(event: any): boolean {
    const leftPosition = 60;
    return event.x >= leftPosition;
  }
}
